import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { reduce, find, remove } from 'lodash';

import { selectors as featuresSelectors } from 'features';
import Heading from 'common/components/Heading';
import Separator from 'common/components/Separator';
import ViewProperty from 'common/components/ViewProperty';
import timezones from 'common/timezones';
import styles from './index.module.css';

const labels = {
  referenceFiatCurrency: 'Reference currency',
  name: 'Merchant name',
  url: 'Website URL',
  companyOfficialName: 'Legal name',
  sector: 'Sector',
  registeredAddress: 'Legal address',
  country: 'Country',
  timezone: 'Timezone',
  vatNumber: 'VAT Number',
};

const Business = ({ name, url, ...props }) => {
  const isReferenceCurrencyActive = useSelector(
    featuresSelectors.isReferenceCurrencyActive
  );

  const companyFields = reduce(
    labels,
    (result, value, key) => {
      const propValue = props[key];

      if (propValue) {
        result.push({
          label: value,
          value:
            key === 'timezone'
              ? find(timezones, { value: propValue })?.label
              : propValue,
          key,
        });
      }
      return result;
    },
    []
  );

  if (props.referenceFiatCurrency && !isReferenceCurrencyActive) {
    remove(companyFields, (n) => n.key === 'referenceFiatCurrency');
  }

  return (
    <div className={styles.root}>
      <Heading level="3" size="3" weight="medium" id={'store-information'}>
        Merchant information
      </Heading>
      <div className={styles.store}>
        <ViewProperty label={labels.name} value={name} />
        <ViewProperty label={labels.url} value={url} />
      </div>
      <div className={styles.separator}>
        <Separator />
      </div>
      <Heading level="3" size="3" weight="medium" id={'company-information'}>
        Company information
      </Heading>
      <div className={styles.company}>
        {companyFields.map(({ label, value }) => (
          <ViewProperty label={label} value={value} key={label} />
        ))}
      </div>
    </div>
  );
};

Business.propTypes = {
  companyOfficialName: PropTypes.string,
  country: PropTypes.string,
  name: PropTypes.string,
  registeredAddress: PropTypes.string,
  sectorId: PropTypes.number,
  settlementCurrency: PropTypes.string,
  timezone: PropTypes.string,
  url: PropTypes.string,
  vatNumber: PropTypes.string,
};

export default Business;
